import { useResizeDetector } from 'react-resize-detector';

import type { useResizeDetectorProps } from 'react-resize-detector';

export function useResize<T extends HTMLElement = any>(args: useResizeDetectorProps<T>) {
  return useResizeDetector(args);
}
